import { makeStyles } from '@mui/styles';
import { FC, ReactNode } from 'react';

const useStyles = makeStyles((theme: any) => ({
  grid: {
    display: 'grid',
    // One column on phones, more as the width allows; min() keeps a single track inside narrow viewports.
    gridTemplateColumns: `repeat(auto-fill, minmax(min(100%, ${theme.spacing(42)}), 1fr))`,
    alignItems: 'start',
    gap: theme.spacing(1.5),
    minWidth: 0,
  },
}));

type CardGridProps = Readonly<{
  children: ReactNode;
}>;

export const CardGrid: FC<CardGridProps> = ({ children }) => {
  const classes = useStyles();

  return <div className={classes.grid}>{children}</div>;
};
